import { useAuthStore } from '@/stores/authStore';
import { useOrganizationStore } from '@/stores/organizationStore';
import { useProfile } from '@/hooks/useProfile';
import { isSimpleOperator } from '@/stores/auth/auth.operator';

/**
 * Auth hook that provides access to authentication state and methods.
 * Profile is sourced from TanStack Query.
 */
export const useAuth = () => {
  const authStore = useAuthStore();
  const organizationStore = useOrganizationStore();
  const { loading, user, session, activeOperator, simpleUser } = authStore;
  const simpleOperator = isSimpleOperator(activeOperator);

  const profileQuery = useProfile(simpleOperator ? undefined : user?.id);

  return {
    user,
    session,
    profile: profileQuery.data ?? null,
    activeOperator,
    simpleUser,
    loading,
    isAuthenticated: authStore.isAuthenticated,
    signIn: authStore.signIn,
    signInSimpleUser: authStore.signInSimpleUser,
    signUp: authStore.signUp,
    signUpWithOrganization: authStore.signUpWithOrganization,
    signOut: authStore.signOut,
    hasRole: organizationStore.hasRole, // Delegate to organization store
    refreshSession: authStore.refreshSession,
    handleApiError: authStore.handleApiError,
  };
};
